import { Injectable } from '@angular/core';
import { TokenModel } from './model/TokenModel';
import { JwtHelperService } from "@auth0/angular-jwt";
import { AppStorage } from "./AppStorage";
import { MessageService } from './MessageService';

@Injectable()
export class AppSession {

    static CHAVE_USUARIO = 'usuario'
    static CHAVE_MENU_RECOMENDACAO = 'menuRecomendacao'
    static CHAVE_MENU_HOME = 'menuHome'
    static CHAVE_LISTA_FAVORITOS_ANALISE_ATIVOS_BOLSA = 'listaFavoritosAnaliseAtivos'
    static CHAVE_LISTA_FAVORITOS_ANALISE_ATIVOS_CRIPTOMOEDAS = 'listaFavoritosAnaliseAtivos_CRIPTOMOEDAS'
    static CHAVE_LISTA_FAVORITOS_ANALISE_ATIVOS_FUNDOS_IMOBILIARIOS = 'listaFavoritosAnaliseAtivos_FUNDOS_IMOBILIARIOS'
    static CHAVE_LISTA_FAVORITOS_ANALISE_ATIVOS_FUNDOS_INDICE = 'listaFavoritosAnaliseAtivos_FUNDOS_INDICE'
    static CHAVE_LISTA_FAVORITOS_ANALISE_ATIVOS_INDICES = 'listaFavoritosAnaliseAtivos_INDICES'
    static CHAVE_LISTA_FAVORITOS_PRISMA_BOLSA_BRA = 'listaFavoritosPrimaBolsaBRA'
    static CHAVE_LISTA_FAVORITOS_PRISMA_BOLSA_EUA = 'listaFavoritosPrimaBolsaEUA'
    static CHAVE_LISTA_FAVORITOS_PRISMA_CRIPTOMOEDAS = 'listaFavoritosPrimaCriptomoedas'
    static CHAVE_LISTA_FAVORITOS_PRISMA_FUNDOS_IMOBILIARIOS = 'listaFavoritosPrimaFUNDOS_IMOBILIARIOS'
    static CHAVE_LISTA_FAVORITOS_PRISMA_FUNDOS_INDICE = 'listaFavoritosPrimaFUNDOS_INDICE'
    static CHAVE_LISTA_FAVORITOS_PRISMA_INDICES_SETORIAIS = 'listaFavoritosPrimaINDICES_SETORIAIS'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_BRASIL = 'listaFavoritosRecomendacaoBrasil'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_EUA = 'listaFavoritosRecomendacaoEUA'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_CRIPTOMOEDAS = 'listaFavoritosRecomendacaoCriptomoedas'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_FUNDOS_IMOBILIARIOS = 'listaFavoritosRecomendacaoFundosImobiliarios'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_FUNDOS_INDICE = 'listaFavoritosRecomendacaoFundosIndice'
    static CHAVE_LISTA_FAVORITOS_RECOMENDACAO_INDICES = 'listaFavoritosRecomendacaoIndices'
    static CHAVE_TOKEN = 'token'
    static CHAVE_ULTIMO_LOGIN = 'ultimoLogin'
    static CHAVE_LISTA_NOTIFICACOES = 'listaNotificacoes'
    static CHAVE_COMMAND_PUSH = "commandPush"
    static CHAVE_TIPO_ATIVO_SELECIONADO_PRISMA = "tipoAtivoSelecionadoPrisma"
    static CHAVE_TIPO_ATIVO_SELECIONADO_ANALISE = "tipoAtivoSelecionadoAnaliseAtivos"
    static CHAVE_TIPO_ATIVO_SELECIONADO_RECOMENDACOES = "tipoAtivoSelecionadoRecomendacoes"
    static CHAVE_CONTRATO_USUARIO = "contratoUsuario"
    static CHAVE_FORMULARIO_TRADER = "formularioTrader"
    static CHAVE_ASSOCIATE_APPLE = "CHAVE_ASSOCIATE_APPLE"
    static CHAVE_WEBTOKEN = "CHAVE_WEBTOKEN"
    static CHAVE_IS_WEB = "CHAVE_IS_WEB"

    static LIST_CLEAR_SESSION: Array<string> = [
        AppSession.CHAVE_USUARIO, 
        AppSession.CHAVE_MENU_RECOMENDACAO,
        AppSession.CHAVE_MENU_HOME,
        AppSession.CHAVE_TOKEN,
        AppSession.CHAVE_CONTRATO_USUARIO
    ]

    static async userAuthenticate(): Promise<boolean> {
        const helper = new JwtHelperService();
        const token: TokenModel = await AppSession.getToken()
        const _isTokenExpired = token ? helper.isTokenExpired(token.access_token) : true
        return !_isTokenExpired
    }

    static async getToken(): Promise<TokenModel> {
        return await AppStorage.get(AppSession.CHAVE_TOKEN)
    }

    static async saveToken(token: TokenModel) {
        await AppStorage.set(AppSession.CHAVE_TOKEN, token)
    }

    static async saveUser(user) {
        await AppStorage.set(AppSession.CHAVE_USUARIO, user)
    }

    static async getUser() {
        return await AppStorage.get(AppSession.CHAVE_USUARIO)
    }

    static async clearSession() {
        await AppStorage.removeListKeys(AppSession.LIST_CLEAR_SESSION)
        MessageService.sendMessage(MessageService.KEY_LOGOFF_APP)
    }
}